import { ThemeApp } from 'themes/types/themeApp/theme.types';
import { themeUi } from '../../themeUi/themeUi';

const accountSettings: ThemeApp['appComponents']['accountSettings'] = {
  account: {
    shared: {
      card: {
        card: {
          backgroundColor: themeUi.semantic.color.background.secondary50,
          boxShadow: themeUi.core.shadow.shadow4
        },

        cardHeader: {
          color: themeUi.semantic.color.text.secondary950,
          borderBottom: themeUi.semantic.color.border.neutral400
        },

        cardContent: {
          backgroundColor: themeUi.semantic.color.background.secondary0
        }
      },

      divider: {
        divider: {
          darkBorderBottom: themeUi.semantic.color.border.neutral500,
          borderBottom: themeUi.semantic.color.border.neutral400
        }
      },

      sectionItem: {
        label: {
          color: themeUi.semantic.color.text.secondary950
        }
      },
      businessSection: {
        accountAddressCard: {
          address: {
            color: themeUi.semantic.color.text.secondary950
          }
        }
      }
    }
  },

  cloudAccounts: {
    addEditModal: {
      form: {
        cloudAccAddEditForm: {
          leftBox: {
            borderRight: themeUi.semantic.color.border.neutral400
          },
          boxTitle: {
            color: themeUi.semantic.color.text.secondary950
          }
        }
      }
    },

    cloudAccountsEmptyResults: {
      readMoreBtn: {
        color: themeUi.semantic.color.text.primary600
      }
    },

    components: {
      tableCells: {
        cells: {
          svgIcon: {
            color: themeUi.semantic.color.icon.primary600
          }
        }
      }
    }
  }
};

export default accountSettings;
